// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ff-1";
export var dateTimeButtonsContainer = "_ff-6";
export var dateTimeInputContainer = "_ff-7";
export var dateTimeWrapper = "_ff-8";
export var disabledTile = "_ff-0";
export var header = "_ff-2";
export var line = "_ff-3";
export var snoozeOption = "_ff-4";
export var time = "_ff-5";
export var todayTile = "_ff-9";
export var wrapper = "_ff-a";